export default __webpack_public_path__ + "media/images/casatb/about_us/murilo-girio-f43258669c5a7380dbb2e8181b8f1e8d.png";